var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-multi-switcher',{staticClass:"ml-4",attrs:{"items":_vm.granularityItems,"value":_vm.granularity},on:{"input":_vm.onGranularityChange}})}
var staticRenderFns = []

export { render, staticRenderFns }